import { ActivityItemPriceModes } from '../ActivityItemPricing/PricingCalculator/PricingCalculatorConsts';

const getCombinationKey = (item) => {
    const selectedLotIds = Array.isArray(item.selectedLotIds) ? [...item.selectedLotIds].sort() : item.selectedLotIds;
    const vendorIds = Array.isArray(item.vendorIds) ? [...item.vendorIds].sort() : item.vendorIds;
    const vehicleTypeIdsList = Array.isArray(item.vehicleTypeIdsList) && item.vehicleTypeIdsList.length > 0
        ? [...item.vehicleTypeIdsList].sort() 
        : null;
    
    return JSON.stringify({
        selectedLotIds,
        vendorIds,
        vehicleTypeIdsList,
        lotOption: item.lotOption
    });
};

export const generateMissingDefaultPricing = (pricingItems) => {
    if (!pricingItems || pricingItems.length === 0) {
        return pricingItems;
    }

    const sortedItems = [...pricingItems].sort((a, b) => {
        const getTimestamp = (item) => {
            if (item.tempId && typeof item.tempId === 'string' && item.tempId.includes('-')) {
                return parseInt(item.tempId.split('-')[0]) || 0;
            }
            return 0;
        };
        return getTimestamp(a) - getTimestamp(b);
    });

    const combinationMap = new Map();
    const combinationsWithNullClient = new Set();

    for (let i = 0; i < sortedItems.length; i++) {
        const item = sortedItems[i];
        const key = getCombinationKey(item);
        
        if (item.clientId === null) {
            combinationsWithNullClient.add(key);
        }
        
        if (item?.priceConfig?.priceMode === ActivityItemPriceModes.MARGIN && !combinationMap.has(key)) {
            combinationMap.set(key, item);
        }
    }

    const generatedDefaults = [];
    combinationMap.forEach((firstItem, key) => {
        if (!combinationsWithNullClient.has(key)) {
            const defaultEntry = {
                ...firstItem,
                clientId: null
            };
            generatedDefaults.push(defaultEntry);
        }
    });

    return [...pricingItems, ...generatedDefaults];
};
